module.exports = __webpack_public_path__ + "b6d52171c79f1ddb0be1c7e55a8f183a.pdf";